import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import Title from "./Title";
import ProgressBar from "./ProgressBar";

function Skills() {
  return (
    <SkillsStyled>
      <Title title={'My Skills'} span={'my skills'} />
      <InnerLayout>
        <div className='skills'>
          <ProgressBar title={'Core Java'} width={'90%'} text={'90%'} />
          <ProgressBar
            title={'Selenium Webdriver'}
            width={'95%'}
            text={'95%'}
          />
          <ProgressBar
            title={'Microservices Testing'}
            width={'95%'}
            text={'95%'}
          />
          <ProgressBar
            title={'Postman/Rest APIs Testing'}
            width={'95%'}
            text={'95%'}
          />
          <ProgressBar title={'SQL/Database'} width={'95%'} text={'95%'} />
          <ProgressBar
            title={'Jenkins /GIT /CI /CD'}
            width={'95%'}
            text={'95%'}
          />
          <ProgressBar title={'Cucumber BDD/Gherkins'} width={'95%'} text={'95%'} />
          <ProgressBar title={'Javascript'} width={'85%'} text={'85%'} />
          <ProgressBar title={'HTML5'} width={'85%'} text={'85%'} />
          <ProgressBar title={'CSS3'} width={'85%'} text={'85%'} />
          <ProgressBar title={'React JS'} width={'85%'} text={'85%'} />
        </div>
      </InnerLayout>
    </SkillsStyled>
  );
}

const SkillsStyled = styled.section`
  .skills {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 2rem;
    grid-column-gap: 3rem;
    @media screen and (max-width: 700px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export default Skills;
